import { MIL_ACTIVE_BASE_PAY_LOOKUP, MIL_BAH_LOOKUP, MIL_ZIPCODES_TO_AREAS } from './militaryData';
export var getMonthlyBahValue = function getMonthlyBahValue(paygrade, zipCode, dependants) {
  var area = MIL_ZIPCODES_TO_AREAS[zipCode];
  var dependantsKey = dependants === 'true' ? 'with_dependants' : 'without_dependants';
  var bahValue = MIL_BAH_LOOKUP[area][dependantsKey][paygrade];
  return bahValue !== undefined ? bahValue : 0;
};
export var getMonthlyActiveBasePay = function getMonthlyActiveBasePay(paygrade, lengthOfService) {
  var monthlyActiveBasePay = MIL_ACTIVE_BASE_PAY_LOOKUP[paygrade][lengthOfService];
  return monthlyActiveBasePay;
};